import $ from 'jquery';
import IScroll from 'iscroll';
import 'jquery-drawer';

window.IScroll = IScroll;
window.$ = $;
window.jQuery = $;
